// extracted by mini-css-extract-plugin
module.exports = {"title":"e_cf","container":"e_df","right":"e_ef","image":"e_ff","scoreLine":"e_gf","scoreRing":"e_hf","badge":"e_if","badgeImage":"e_jf","badgeRing":"e_kf","large":"e_lf"};